export const cases = [
  {
    desc: '出差需求单对接方案，员工只需填写一张出差需求单，后续所有服务及流程由特航提供。',
    image: '/images/pages/tmc/case-1.png',
  },
  {
    desc: '协助财务做好差旅整合，完善审批政策，执行出差审批与报销制度，有效降低成本。',
    image: '/images/pages/tmc/case-2.png',
  },
  {
    desc: '协助中海油集团进行全集团的差旅整合，系统对接，协助谈判航空公司大客户协议。',
    image: '/images/pages/tmc/case-3.png',
  },
  {
    desc: '系统对接多供应商竞价模式，OA出差申请单与机票订单关联、领导审批状态同步、机票订单信息同步显示在OA中。',
    image: '/images/pages/tmc/case-4.png',
  },
  {
    desc: '对接OA及财务后台系统，协助财务做好差旅整合，进一步完善了审批、出差、报销流程和制度，有效的降低企业的差旅成本，减少工作量。',
    image: '/images/pages/tmc/case-5.png',
  },
  {
    desc: '协助华强集团整合下属30多家分子公司，提供OA系统、财务系统全流程对接解决方案。',
    image: '/images/pages/tmc/case-6.png',
  },
]
